import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateTag from "../../components/ProductManager/Tag/UpdateTag";

export const UpdateTagPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateTag />
        </div>
      </div>
    </div>
  );
};
